import {
	Component,
	OnInit,
	ViewChild,
	ElementRef,
	AfterViewInit,
	HostListener,
} from "@angular/core";
import { FormGroup, FormBuilder, FormArray, Validators } from "@angular/forms";
import { TotBatchService } from "projects/services/src/app/API/tot-batch.service";
import { BatchService } from "projects/services/src/app/API/batch.service";
import { ScriptLoaderService } from "projects/services/src/app/script-loader.service";
import { Helpers } from "projects/training-calendar/src/app/helpers";
import { DateFormatPipe } from "src/app/pipes/dateformat.pipe";

declare var $: any;
declare const swal: any;
declare const toastr: any;

import * as moment from "moment";
import { Location } from "@angular/common";
import { FileService } from "projects/services/src/app/API/document/file.service";
import { CurrentUserService } from "projects/services/src/app/current-user.service";
import { UserService } from "projects/services/src/app/API/user.service";
import { Router } from "@angular/router";
@Component({
	selector: "app-view-batches-for-applicant",
	templateUrl: "./view-batches-for-applicant.component.html",
	styleUrls: ["./view-batches-for-applicant.component.css"],
	providers: [DateFormatPipe],
})
export class ViewBatchesForApplicantComponent implements OnInit, AfterViewInit {
	filterObj: {};
	feedBackForm: FormGroup;
	@HostListener("scroll", ["$event"])
	pageNo: any = 1;
	itemPerPage: any = 10;
	count: any;
	batchData: any;
	applicantData: any;
	paymentData: any;
	filterData: {};
	userInfo: any;
	certificateFileName: any;
	todayDate = new Date();
	comments = {
		reason: "",
		label: "",
		date: "",
		time: "",
		comment: "",
	};
	actualFees: any;
	batchFeeDetailsForm: FormGroup;
	currentCertificate: any;
	isFeedback: boolean = false;
	modeOfPayement = [
		"Bank Challan",
		"Cash",
		"Cheque",
		"Demand Draft",
		"Debit/Credit Card",
		"NetBanking/Online,",
		"Others",
	];
	bankNames = [
		"Allahabad Bank",
		"Andhra Bank",
		"Axis Bank",
		"Bandhan Bank",
		"Bank of Baroda",
		"Bank of India",
		"Bank of Maharashtra",
		"Canara Bank",
		"Catholic Syrian Bank",
		"Central Bank of India",
		"City Union Bank",
		"Corporation Bank",
		"DCB Bank",
		"Dena Bank",
		"Dhanlaxmi Bank",
		"Federal Bank",
		"HDFC Bank",
		"ICICI Bank",
		"IDBI Bank",
		"IDFC Bank",
		"Indian Bank",
		"Indian Overseas Bank",
		"IndusInd Bank",
		"Jammu & Kashmir Bank",
		"Karnataka Bank",
		"Karur Vysya Bank",
		"Kotak Mahindra Bank",
		"Lakshmi Vilas Bank",
		"Nainital Bank",
		"Oriental Bank of Commerce",
		"Punjab and Sind Bank",
		"Punjab National Bank",
		"RBL Bank",
		"South Indian Bank",
		"State Bank of India",
		"Syndicate Bank",
		"Tamilnad Mercantile Bank Limited",
		"UCO Bank",
		"Union Bank of India",
		"United Bank of India",
		"Vijaya Bank",
		"Yes Bank",
		"Other",
	];
	dateObject = {
		date: new Date(),
		placeholder: "Select Date",
		format: "dd/MM/yyyy",
	};
	customFilterFields = {
		state: true,
		district: true,
		batchType: true,
		jobRoles: false,
		centre: false,
		batchStatus: false,
		keyword: true,
		startDt: false,
		endDt: false,
	};
	isChecked = false;
	constructor(
		private _totService: TotBatchService,
		private _batchService: BatchService,
		private _formBuilder: FormBuilder,
		private scriptLoaderService: ScriptLoaderService,
		private convert: DateFormatPipe,
		private location: Location,
		private fileDownload: FileService,
		private currentUser: CurrentUserService,
		private userService: UserService,
		private router: Router
	) {
		this.defineForm();
	}

	defineForm() {
		this.batchFeeDetailsForm = this._formBuilder.group({
			modeOfPayment: ["", [Validators.required]],
			nameOfBank: ["", [Validators.required]],
			dateOfPayment: ["", [Validators.required]],
			dateId: Helpers.defineCalendar(new Date("1/1/1990"), new Date()),
			refNo: [
				"",
				[
					Validators.required,
					Validators.pattern("^[A-Za-z0-9][A-Za-z0-9-/,()&.:s ]*$"),
					Validators.maxLength(30),
				],
			],
			remarks: [
				"",
				[
					Validators.pattern("^[A-Za-z0-9][A-Za-z0-9-/,()&.:s ]*$"),
					Validators.maxLength(1000),
				],
			],
			amount: [
				this.actualFees ? this.actualFees : null,
				[Validators.required],
			],
		});
	}

	ngOnInit() {
		this.getBatches();
		this.getCurrentUser();
	}

	getFeeDetails() {
		console.log(this.paymentData);
		if (this.paymentData && this.paymentData.batchFee) {
			const discountValidTill = new Date(
				this.paymentData.batchFee.discountValidTill
			);
			discountValidTill.setHours(0, 0, 0, 0);
			const todayDate = new Date();
			todayDate.setHours(0, 0, 0, 0);
			if (
				this.paymentData.batchFee.isOfferApplied &&
				discountValidTill >= todayDate
			) {
				this.actualFees = this.paymentData.batchFee.feeAfterDiscount;
			} else {
				this.actualFees = this.paymentData.batchFee.totalFees;
			}
		}
	}

	scrollHandler() {
		$(".datepicker-dropdown").css("display", "none");
		$(".calender").blur();
	}
	getFilterData(data) {
		console.log(event);
		this.filterObj = {};
		this.filterObj = data;
		this.filterObj["isFilter"] = true;
		this.getBatches(this.filterObj);
	}
	resetFilter() {
		this.filterObj = {};
		this.filterObj["isFilter"] = false;
		this.getBatches(this.filterObj);
	}
	ngAfterViewInit() {
		this.scriptLoaderService.loadScripts("app-view-batches-for-applicant", [
			"./assets/demo/default/custom/components/forms/widgets/bootstrap-datepicker.js",
			"./assets/demo/default/custom/components/forms/widgets/bootstrap-select.js",
		]);
	}
	setValidators() {
		if (this.batchFeeDetailsForm.get("modeOfPayment").value === "Cash") {
			this.batchFeeDetailsForm.get("nameOfBank").setErrors(null);
		}
	}
	getBatches(data = {}) {
		this._batchService
			.getApplicantBatches(this.pageNo, this.itemPerPage, data)
			.subscribe(
				(res) => {
					console.log(res);
					if (res) {
						this.applicantData = res.data;
						this.applicantData.filter((batches) => {
							batches.batch.candidates.jobRole.filter((Cjobs) => {
								batches.batch.jobRoles.filter((jobs) => {
									if (Cjobs.qpCode === jobs.qpCode) {
										Cjobs.isPlatformQP = jobs.isPlatformQP;
										console.log(Cjobs, batches);
										if (
											Cjobs.isMarkSheetGenerated === true
										) {
											batches.batch.showDownload = true;
										}
									}
								});
							});
						});
						console.log(this.applicantData);
					} else {
						this.applicantData = [];
					}
				},
				(err) => {
					this.applicantData = [];
				}
			);
	}

	getMarksheetDetails(batchId, qpCode) {
		this._totService
			.getMarkSheetDetails(batchId, this.userInfo.userName, qpCode)
			.subscribe((marksheetDetails) => {
				// console.log(marksheetDetails);
				this.fileDownload.downloadAttachedFile(
					marksheetDetails.data.location
				);
			});
	}

	getCertificateDetails(batch, qpCode) {
		if (batch.candidates.feedback) {
			this._totService
				.getCertificateDetails(
					batch.batchId,
					this.userInfo.userName,
					qpCode
				)
				.subscribe((certificationDetails) => {
					this.currentCertificate = certificationDetails.data;
					this.viewCertificateDetails();
					if (this.currentCertificate.isValidityExtended) {
						Helpers.openModal("m_modal_2");
					} else {
						this.fileDownload.downloadAttachedFile(
							certificationDetails.data.location
						);
					}
				});
		} else {
			swal({
				title: `To download certificate, you need to provide feedback. Do you want to Proceed?`,
				type: "info",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				cancelButtonColor: "#d33",
			}).then((action: any) => {
				if (action.value) {
					// $('#provide_feedback_modal').modal('show');
					this.provideFeedback(batch, qpCode);
					Helpers.openModal("provide_feedback_modal");
				}
			});
		}
	}

	downloadCertificate(key) {
		this.fileDownload.downloadAttachedFile(key);
	}

	viewCertificateDetails() {
		if (this.currentCertificate && this.currentCertificate.key) {
			const certificateFile = this.currentCertificate.key;
			const splitCertificateFile = certificateFile.split("/");
			this.certificateFileName = splitCertificateFile.pop();
		} else if (
			this.currentCertificate &&
			this.currentCertificate.location
		) {
			const certificateFile = this.currentCertificate.location;
			const splitCertificateFile = certificateFile.split("/");
			this.certificateFileName = splitCertificateFile.pop();
		}
	}

	createFeedbackForm(batch, feedback?) {
		this.feedBackForm = this._formBuilder.group({
			feedBack: this._formBuilder.group({
				date: [new Date().toISOString()],
				feedbackForTC: this._formBuilder.group({
					preCommunication: [
						feedback &&
						feedback.feedbackForTC &&
						feedback.feedbackForTC.preCommunication
							? {
									value: String(
										feedback.feedbackForTC.preCommunication
									),
									disabled: true,
							  }
							: null,
						Validators.required,
					],
					qualityOfStudyMaterials: [
						feedback &&
						feedback.feedbackForTC &&
						feedback.feedbackForTC.qualityOfStudyMaterials
							? {
									value: String(
										feedback.feedbackForTC
											.qualityOfStudyMaterials
									),
									disabled: true,
							  }
							: null,
						Validators.required,
					],
					qualityOfTraining: [
						feedback &&
						feedback.feedbackForTC &&
						feedback.feedbackForTC.qualityOfTraining
							? {
									value: String(
										feedback.feedbackForTC.qualityOfTraining
									),
									disabled: true,
							  }
							: null,
						Validators.required,
					],
					qualityOfTools: [
						feedback &&
						feedback.feedbackForTC &&
						feedback.feedbackForTC.qualityOfTools
							? {
									value: String(
										feedback.feedbackForTC.qualityOfTools
									),
									disabled: true,
							  }
							: null,
						Validators.required,
					],
					postCommunication: [
						feedback &&
						feedback.feedbackForTC &&
						feedback.feedbackForTC.postCommunication
							? {
									value: String(
										feedback.feedbackForTC.postCommunication
									),
									disabled: true,
							  }
							: null,
						Validators.required,
					],
				}),
				feedbackForMTTraining: this._formBuilder.group({
					learningExtent: [
						feedback &&
						feedback.feedbackForMTTraining.learningExtent
							? {
									value: String(
										feedback.feedbackForMTTraining
											.learningExtent
									),
									disabled: true,
							  }
							: null,
						Validators.required,
					],
					learningEnvironment: [
						feedback &&
						feedback.feedbackForMTTraining.learningEnvironment
							? {
									value: String(
										feedback.feedbackForMTTraining
											.learningEnvironment
									),
									disabled: true,
							  }
							: null,
						Validators.required,
					],
				}),
				recommendation: [
					feedback && feedback.recommendation
						? { value: feedback.recommendation, disabled: true }
						: null,
					Validators.required,
				],
				overAllRating: [
					feedback && feedback.overAllRating
						? {
								value: String(feedback.overAllRating),
								disabled: true,
						  }
						: null,
					Validators.required,
				],
				overAllComment: [
					feedback && feedback.overAllComment
						? { value: feedback.overAllComment, disabled: true }
						: null,
					Validators.required,
				],
				feedbackForMT: this._formBuilder.array([]),
				feedbackForAssessor: this._formBuilder.array([]),
			}),
		});
		for (let j = 0; j < batch.jobRoles.length; j++) {
			if (feedback) {
				if (
					batch.type !== "Training of Trainer-Existing" &&
					batch.type !== "Training of Assessor-Existing"
				) {
					const masterTrainerData = this.feedBackForm
						.get("feedBack")
						.get("feedbackForMT") as FormArray;
					masterTrainerData.push(
						this.feedBackForMT(
							batch.jobRoles[j],
							feedback.feedbackForMT[j]
						)
					);
				}
				const masterAssessorData = this.feedBackForm
					.get("feedBack")
					.get("feedbackForAssessor") as FormArray;
				masterAssessorData.push(
					this.feedBackForAR(
						batch.jobRoles[j],
						feedback.feedbackForAssessor[j]
					)
				);
			} else {
				if (
					batch.type !== "Training of Trainer-Existing" &&
					batch.type !== "Training of Assessor-Existing"
				) {
					const masterTrainerData = this.feedBackForm
						.get("feedBack")
						.get("feedbackForMT") as FormArray;
					masterTrainerData.push(
						this.feedBackForMT(batch.jobRoles[j])
					);
				}
				const masterAssessorData = this.feedBackForm
					.get("feedBack")
					.get("feedbackForAssessor") as FormArray;
				masterAssessorData.push(this.feedBackForAR(batch.jobRoles[j]));
			}
		}
	}

	provideFeedback(batch, qpCode) {
		this.batchData = batch;
		console.log(this.batchData);
		if (this.batchData.candidates.feedback) {
			toastr.error("Feedback Already Provided");
		} else {
			this.isFeedback = true;
			this.createFeedbackForm(batch);
			if (
				this.batchData.applicantsEnrollmentBy === "SSC" ||
				this.batchData.totMode === "online"
			) {
				this.feedBackForm
					.get("feedBack")
					.get("feedbackForTC")
					.get("preCommunication")
					.setValidators([]);
				this.feedBackForm
					.get("feedBack")
					.get("feedbackForTC")
					.get("preCommunication")
					.updateValueAndValidity();
				this.feedBackForm
					.get("feedBack")
					.get("feedbackForTC")
					.get("qualityOfStudyMaterials")
					.setValidators([]);
				this.feedBackForm
					.get("feedBack")
					.get("feedbackForTC")
					.get("qualityOfStudyMaterials")
					.updateValueAndValidity();
				this.feedBackForm
					.get("feedBack")
					.get("feedbackForTC")
					.get("qualityOfTraining")
					.setValidators([]);
				this.feedBackForm
					.get("feedBack")
					.get("feedbackForTC")
					.get("qualityOfTraining")
					.updateValueAndValidity();
				this.feedBackForm
					.get("feedBack")
					.get("feedbackForTC")
					.get("qualityOfTools")
					.setValidators([]);
				this.feedBackForm
					.get("feedBack")
					.get("feedbackForTC")
					.get("qualityOfTools")
					.updateValueAndValidity();
				this.feedBackForm
					.get("feedBack")
					.get("feedbackForTC")
					.get("postCommunication")
					.setValidators([]);
				this.feedBackForm
					.get("feedBack")
					.get("feedbackForTC")
					.get("postCommunication")
					.updateValueAndValidity();
			}
			if (
					batch.type === "Training of Trainer-Existing" ||
					batch.type === "Training of Assessor-Existing"
				) {
				this.feedBackForm.get('feedBack').get('feedbackForMTTraining').get('learningExtent').setValidators([]);
				this.feedBackForm.get('feedBack').get('feedbackForMTTraining').get('learningExtent').updateValueAndValidity();
				this.feedBackForm.get('feedBack').get('feedbackForMTTraining').get('learningEnvironment').setValidators([]);
				this.feedBackForm.get('feedBack').get('feedbackForMTTraining').get('learningEnvironment').updateValueAndValidity();
				}
			Helpers.openModal("provide_feedback_modal");
		}
	}

	feedBackForMT(data, feedback?): FormGroup {
		return this._formBuilder.group({
			qpCode: [data ? data.qpCode : ""],
			qpName: [data ? data.jobName : ""],
			isPlatformQP: [data ? data.isPlatformQP : false],
			name: [
				data
					? data.masterTrainerDetails.name
						? data.masterTrainerDetails.name
						: ""
					: "",
			],
			userName: [
				data
					? data.masterTrainerDetails.userName
						? data.masterTrainerDetails.userName
						: ""
					: "",
			],
			knowledge: [
				feedback && feedback.knowledge
					? { value: String(feedback.knowledge), disabled: true }
					: null,
				Validators.required,
			],
			sessions: [
				feedback && feedback.sessions
					? { value: String(feedback.sessions), disabled: true }
					: null,
				Validators.required,
			],
			presentation: [
				feedback && feedback.presentation
					? { value: String(feedback.presentation), disabled: true }
					: null,
				Validators.required,
			],
			exampleUsage: [
				feedback && feedback.exampleUsage
					? { value: String(feedback.exampleUsage), disabled: true }
					: null,
				Validators.required,
			],
			interactive: [
				feedback && feedback.interactive
					? { value: String(feedback.interactive), disabled: true }
					: null,
				Validators.required,
			],
			curriculum: [
				feedback && feedback.curriculum
					? { value: String(feedback.curriculum), disabled: true }
					: null,
				Validators.required,
			],
		});
	}

	// feedBackForMTTraining(data, feedback?): FormGroup {
	// 	return this._formBuilder.group({
	// 		qpCode: [data ? data.qpCode : ''],
	// 		name: [data ? (data.masterTrainerDetails.name ? data.masterTrainerDetails.name : '') : ''],

	// 	})
	// }

	feedBackForAR(data, feedback?): FormGroup {
		return this._formBuilder.group({
			qpCode: [data ? data.qpCode : ""],
			qpName: [data ? data.jobName : ""],
			isPlatformQP: [data ? data.isPlatformQP : false],
			name: [
				data
					? data.assessmentAgencyDetails.assessorDetails &&
					  data.assessmentAgencyDetails.assessorDetails.name
						? data.assessmentAgencyDetails.assessorDetails.name
						: ""
					: "",
			],
			userName: [
				data
					? data.assessmentAgencyDetails.assessorDetails &&
					  data.assessmentAgencyDetails.assessorDetails.userName
						? data.assessmentAgencyDetails.assessorDetails.userName
						: ""
					: "",
			],
			preAssessment: [
				feedback && feedback.preAssessment
					? { value: String(feedback.preAssessment), disabled: true }
					: null,
				Validators.required,
			],
			conduct: [
				feedback && feedback.conduct
					? { value: String(feedback.conduct), disabled: true }
					: null,
				Validators.required,
			],
			assessmentExperience: [
				feedback && feedback.assessmentExperience
					? {
							value: String(feedback.assessmentExperience),
							disabled: true,
					  }
					: null,
				Validators.required,
			],
		});
	}

	viewFeedback(batch) {
		if (batch.candidates.feedback) {
			this.batchData = batch;
			this.createFeedbackForm(batch, batch.candidates.feedback);
			console.log(this.createFeedbackForm);
			this.isFeedback = true;
			this.feedBackForm.get("feedBack");
			const formValue = this.feedBackForm.getRawValue();
			console.log(formValue);
		}
	}

	disableFields(inputName) {
		let inputField;
		inputField = document.querySelectorAll(inputName);
		for (let control of inputField) {
			if (!control.checked) {
				control.disabled = true;
			}
		}
	}

	assignPageNo(pageNo) {
		this.pageNo = pageNo;
		this.getBatches();
	}

	assignRecordsPerPage(itemPerPage) {
		this.itemPerPage = itemPerPage;
		this.getBatches();
	}

	feedbackSubmitted(fbData?) {
		console.log("Feed Back", this.feedBackForm);
		const feedBack = this.feedBackForm.value.feedBack;
		feedBack.feedbackForTC.preCommunication = Number(
			feedBack.feedbackForTC.preCommunication
		);
		feedBack.feedbackForTC.qualityOfStudyMaterials = Number(
			feedBack.feedbackForTC.qualityOfStudyMaterials
		);
		feedBack.feedbackForTC.qualityOfTraining = Number(
			feedBack.feedbackForTC.qualityOfTraining
		);
		feedBack.feedbackForTC.qualityOfTools = Number(
			feedBack.feedbackForTC.qualityOfTools
		);
		feedBack.feedbackForTC.postCommunication = Number(
			feedBack.feedbackForTC.postCommunication
		);
		feedBack.feedbackForMTTraining.learningExtent = Number(
			feedBack.feedbackForMTTraining.learningExtent
		);
		feedBack.feedbackForMTTraining.learningEnvironment = Number(
			feedBack.feedbackForMTTraining.learningEnvironment
		);
		feedBack.overAllRating = Number(feedBack.overAllRating);
		for (let i = 0; i < feedBack.feedbackForMT.length; i++) {
			feedBack.feedbackForMT[i].knowledge = Number(
				feedBack.feedbackForMT[i].knowledge
			);
			feedBack.feedbackForMT[i].sessions = Number(
				feedBack.feedbackForMT[i].sessions
			);
			feedBack.feedbackForMT[i].presentation = Number(
				feedBack.feedbackForMT[i].presentation
			);
			feedBack.feedbackForMT[i].exampleUsage = Number(
				feedBack.feedbackForMT[i].exampleUsage
			);
			feedBack.feedbackForMT[i].interactive = Number(
				feedBack.feedbackForMT[i].interactive
			);
			feedBack.feedbackForMT[i].curriculum = Number(
				feedBack.feedbackForMT[i].curriculum
			);
		}
		for (
			let index = 0;
			index < feedBack.feedbackForAssessor.length;
			index++
		) {
			feedBack.feedbackForAssessor[index].preAssessment = Number(
				feedBack.feedbackForAssessor[index].preAssessment
			);
			feedBack.feedbackForAssessor[index].conduct = Number(
				feedBack.feedbackForAssessor[index].conduct
			);
			feedBack.feedbackForAssessor[index].assessmentExperience = Number(
				feedBack.feedbackForAssessor[index].assessmentExperience
			);
		}
		this._batchService
			.postFeedBack(feedBack, this.batchData.batchId)
			.subscribe((res) => {
				swal(
					"Feedback Submitted Successfully",
					"Your feedback for the training has been successfully submitted",
					"success"
				);

				this.getBatches();
				this.disabledFeedbackFields();
				this.feedBackForm
					.get("feedBack")
					.get("overAllComment")
					.disable();
				// Helpers.closeModal('provide_feedback_modal')
			});
	}

	disabledFeedbackFields() {
		this.feedBackForm
			.get("feedBack")
			.get("feedbackForTC")
			.get("preCommunication")
			.disable();
		this.feedBackForm
			.get("feedBack")
			.get("feedbackForTC")
			.get("qualityOfStudyMaterials")
			.disable();
		this.feedBackForm
			.get("feedBack")
			.get("feedbackForTC")
			.get("qualityOfTraining")
			.disable();
		this.feedBackForm
			.get("feedBack")
			.get("feedbackForTC")
			.get("qualityOfTools")
			.disable();
		this.feedBackForm
			.get("feedBack")
			.get("feedbackForTC")
			.get("postCommunication")
			.disable();

		this.feedBackForm
			.get("feedBack")
			.get("feedbackForMTTraining")
			.get("learningExtent")
			.disable();
		this.feedBackForm
			.get("feedBack")
			.get("feedbackForMTTraining")
			.get("learningEnvironment")
			.disable();

		this.feedBackForm.get("feedBack").get("recommendation").disable();
		this.feedBackForm.get("feedBack").get("overAllRating").disable();
		this.feedBackForm.get("feedBack").get("overAllComment").disable();
	}

	openModal(data) {
		console.log(data);
		this.paymentData = data.batch;
		this.getFeeDetails();
		this.defineForm();
	}

	addPayment() {
		this.batchFeeDetailsForm
			.get("dateOfPayment")
			.setValue(
				this.convert.transform(
					this.batchFeeDetailsForm.value.dateOfPayment
				)
			);
		if (
			this.paymentData.candidates &&
			this.paymentData.candidates.paymentDetails &&
			this.paymentData.candidates.paymentDetails.modeOfPayment !== ""
		) {
			swal("Payment Details Already Submitted", "", "warning");
		} else {
			this._batchService
				.updateApplicantPaymentDetails(
					this.paymentData.batchId,
					this.batchFeeDetailsForm.value
				)
				.subscribe((res) => {
					console.log(res);
					swal(
						"Payment Details Added Successfully !!",
						"Payment details has been added to the " +
							this.paymentData.batchName,
						"success"
					);
				});
		}
		this.getBatches();
		this.getCurrentUser();
	}

	getCurrentUser() {
		this.currentUser.getCurrentUser().subscribe((loggedInUser) => {
			this.userInfo = loggedInUser;
			console.log(this.userInfo);
		});
	}

	setDateOfPayment(event) {
		this.batchFeeDetailsForm
			.get("dateOfPayment")
			.setValue(event.target.value);
		this.batchFeeDetailsForm.get("dateOfPayment").clearValidators();
	}

	onDateChange(event) {
		console.log(this.batchFeeDetailsForm.value.dateId);
		this.dateObject.date = new Date(event);
		this.batchFeeDetailsForm.get("dateOfPayment").setValue(event);
	}

	showComment(data) {
		console.log("comments", data.batch.candidates);
		// console.log(!data.batch.candidates.tcComments.reason);
		// console.log(!data.batch.candidates.sscComments.reason);
		if (!!data.batch.candidates.tcComments.reason) {
			this.comments.reason = data.batch.candidates.tcComments.reason;
			this.comments.label = "Training Centre";
		} else if (!!data.batch.candidates.sscComments.reason) {
			this.comments.reason = data.batch.candidates.sscComments.reason;
			this.comments.label = "SSC";
		} else {
			this.comments.reason = "No Comments Available !";
		}

		if (
			data.batch.candidates.tcComments ||
			data.batch.candidates.sscComments
		) {
			this.comments.comment =
				data.batch.candidates.tcComments.comment ||
				data.batch.candidates.sscComments.comment;
		}

		if (
			data.batch.candidates.statusChangedOn &&
			data.batch.candidates.statusChangedOn !== null
		) {
			this.comments["date"] = moment(
				data.batch.candidates.statusChangedOn
			).format("DD-MM-YYYY");
			this.comments["time"] = moment(
				data.batch.candidates.statusChangedOn
			).format("hh:mm a");
		} else {
			this.comments["date"] = "";
			this.comments["time"] = "";
		}
	}

	applyAdvancedCertificate(batch, jobRole) {
		const displayTab = "Other";
		const status = "Approved";
		let currentCertificate;
		this.filterData = {
			sector: batch.sector.id,
			jobRole: jobRole.qpCode,
			typeOfCertification: "Advanced",
		};
		this.userService
			.getCertificatesAddedForApprovales(
				this.pageNo,
				this.itemPerPage,
				displayTab,
				this.filterData
			)
			.subscribe((res) => {
				if (res.data !== null) {
					toastr.error("Certification request already exists");
				} else {
					this.userService
						.getIndividualCertificateDetails(
							batch.sector.id,
							jobRole.qpCode,
							batch.type,
							this.userInfo.userName
						)
						.subscribe((certificationDetails) => {
							if (certificationDetails.data) {
								currentCertificate =
									certificationDetails.data[0];
								if (this.userInfo.role === "Trainer") {
									this.router.navigate(
										[
											"trainer/applicant/applicant-advance-certificate",
										],
										{
											queryParams: {
												tab: status,
												userName:
													this.userInfo.userName,
												batchType: batch.type,
												certReqId:
													currentCertificate.certReqId,
												qpCode: jobRole.qpCode,
												sectorId: batch.sector.id,
											},
										}
									);
								} else if (this.userInfo.role === "Assessor") {
									this.router.navigate(
										[
											"assessor/applicant/applicant-advance-certificate",
										],
										{
											queryParams: {
												tab: status,
												userName:
													this.userInfo.userName,
												batchType: batch.type,
												certReqId:
													currentCertificate.certReqId,
												qpCode: jobRole.qpCode,
												sectorId: batch.sector.id,
											},
										}
									);
								}
							}
						});
				}
			});
	}

	goBack() {
		this.location.back();
	}
}
